import { ACTIVITY_TYPE } from "./enums";
import { ACTIVITY_TYPE_LABELS } from "./labels";

const TASK_UPDATE_PREFIX = "Aufgabe aktualisiert:";

function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function isTaskUpdateNote(activity) {
  if (!activity) return false;
  if (activity.type !== ACTIVITY_TYPE.NOTE) return false;
  if (!isNonEmptyString(activity.related_task_id)) return false;
  if (!isNonEmptyString(activity.description)) return false;
  return String(activity.description).startsWith(TASK_UPDATE_PREFIX);
}

export function getActivityDisplayLabel(activity) {
  if (isTaskUpdateNote(activity)) return "Aufgabe aktualisiert";
  return ACTIVITY_TYPE_LABELS[activity?.type]?.de || activity?.type || "";
}

export function getActivityDisplayDescription(activity) {
  const raw = activity?.description;
  if (!isNonEmptyString(raw)) return raw;
  if (!isTaskUpdateNote(activity)) return raw;
  const stripped = String(raw).slice(TASK_UPDATE_PREFIX.length).trimStart();
  return stripped || raw;
}
